export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
// export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
// export const LOGOUT_ERROR = 'LOGOUT_ERROR';

export default { LOGOUT_REQUEST };
